
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/share-your-story",
      function () {
        return require("private-next-pages/share-your-story/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/share-your-story"])
      });
    }
  